import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { OrderedList, UnorderedList } from '@chakra-ui/react';
var List = function List(_ref) {
  var color = _ref.color,
    _ref$children = _ref.children,
    children = _ref$children === undefined ? undefined : _ref$children,
    listStyleType = _ref.listStyleType,
    _ref$ordered = _ref.ordered,
    ordered = _ref$ordered === undefined ? false : _ref$ordered,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === undefined ? '0.5em' : _ref$spacing,
    _ref$unstyled = _ref.unstyled,
    unstyled = _ref$unstyled === undefined ? false : _ref$unstyled;
  var computedProps = _objectSpread2({
    color: color,
    listStyleType: listStyleType
  }, unstyled && {
    listStyleType: 'none',
    ms: '0',
    ps: '0'
  });

  /**
   * DOM
   */
  if (ordered) {
    return /*#__PURE__*/React.createElement(OrderedList, _extends({
      "data-testid": "core-ordered-list",
      spacing: spacing
    }, computedProps), children);
  }
  return /*#__PURE__*/React.createElement(UnorderedList, _extends({
    "data-testid": "core-unordered-list",
    spacing: spacing
  }, computedProps), children);
};
List.displayName = "List";
export { List };